import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTrashAlt} from '@fortawesome/free-solid-svg-icons';

const Group = ({group, api}) => {

    const deleteGroup = async() => {
        await api.deleteGroup(group.id, group.name);
        api.getGroups();
    }

    return <tr>
        <th scope="row">{group.name}</th>
        <td>{group.domain}</td>
        <td className="text-right">
            <button className="btn" onClick={deleteGroup}><FontAwesomeIcon className={`Outlet-icon`} icon={faTrashAlt} title="Delete" /></button>
        </td>
    </tr>
}

export default Group;